import ajax from 'api/ajax'

class Login {
  // login
  login = (user, pwd) => ajax('login/login', {user, pwd}, 'post')
  // 获取部门
    getDepartment = (per_page, page ,list) => ajax('chem-dict-school/search',{'per-page':per_page, page ,list})
}

export default Login
